import styled from 'styled-components';

export const StatusContainer = styled.div`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  & .exp{
    visibility: hidden;
  }
  &:hover{
    .exp{
      visibility: visible;
    }
  }
`

export const TokenIcon = styled.img`
  
`

export const Explanation = styled.div`
  position: absolute;
  padding: 10px 15px;
  width: 250px;
  bottom: 25px;
  right: 0;
  z-index: 10;
  background-color: #E6EBFC;
  backdrop-filter: blur(200px);
  border-radius: 10px;
`